module.exports = __webpack_public_path__ + "img/Multimedia.76d73d4b.png";